module.exports = __webpack_public_path__ + "static/img/software11.76fd6ab4.png";